// ScrollToTop.jsx
// با راوتر «دیتا» (RouterProvider/createBrowserRouter) مرورگر گاهی موقعیت اسکرول
// صفحه‌ی قبلی رو نگه می‌داره یا خودش «scroll restoration» انجام می‌ده. این کامپوننت
// آن رفتار پیش‌فرض مرورگر رو خاموش می‌کنه و با هر تغییر مسیر، صفحه رو دستی به بالا
// برمی‌گردونه (به‌جز وقتی لینک به یک anchor/#hash داخل همون صفحه باشه).

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  // رفتار پیش‌فرض بازگردانی اسکرول مرورگر رو غیرفعال می‌کنیم تا خودمون کنترلش کنیم
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    // اگه لینک به یک بخش خاص از همون صفحه بود (#id)، اسکرول رو دست‌نخورده می‌ذاریم
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
